import * as React from 'react'
import createSvgIcon from './createSvgIcon'
import styled from 'styled-components/macro'

const DollarCircle = createSvgIcon(
  <React.Fragment>
    <g clipPath="url(#clip0_355_5380)">
      <path
        d="M3.50195 12C3.50195 13.1819 3.73474 14.3522 4.18704 15.4442C4.63933 16.5361 5.30226 17.5282 6.13799 18.364C6.97372 19.1997 7.96587 19.8626 9.0578 20.3149C10.1497 20.7672 11.3201 21 12.502 21C13.6838 21 14.8542 20.7672 15.9461 20.3149C17.038 19.8626 18.0302 19.1997 18.8659 18.364C19.7016 17.5282 20.3646 16.5361 20.8169 15.4442C21.2692 14.3522 21.502 13.1819 21.502 12C21.502 10.8181 21.2692 9.64778 20.8169 8.55585C20.3646 7.46392 19.7016 6.47177 18.8659 5.63604C18.0302 4.80031 17.038 4.13738 15.9461 3.68508C14.8542 3.23279 13.6838 3 12.502 3C11.3201 3 10.1497 3.23279 9.0578 3.68508C7.96587 4.13738 6.97372 4.80031 6.13799 5.63604C5.30226 6.47177 4.63933 7.46392 4.18704 8.55585C3.73474 9.64778 3.50195 10.8181 3.50195 12Z"
        fill="none"
        stroke="var(--text-heading)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.302 9.00003C15.1208 8.6858 14.8576 8.42674 14.5405 8.25059C14.2235 8.07444 13.8645 7.98783 13.502 8.00003H11.502C10.9715 8.00003 10.4628 8.21075 10.0877 8.58582C9.71267 8.96089 9.50195 9.4696 9.50195 10C9.50195 10.5305 9.71267 11.0392 10.0877 11.4142C10.4628 11.7893 10.9715 12 11.502 12H13.502C14.0324 12 14.5411 12.2107 14.9162 12.5858C15.2912 12.9609 15.502 13.4696 15.502 14C15.502 14.5305 15.2912 15.0392 14.9162 15.4142C14.5411 15.7893 14.0324 16 13.502 16H11.502C11.1394 16.0122 10.7804 15.9256 10.4634 15.7495C10.1463 15.5733 9.8831 15.3143 9.70195 15"
        fill="none"
        stroke="var(--text-heading)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.502 7V17"
        fill="none"
        stroke="var(--text-heading)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_355_5380">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.501953)"
        />
      </clipPath>
    </defs>
  </React.Fragment>,
  'DollarCircle'
)

export default styled(DollarCircle)`
  g {
    transform: translateX(2px) translateY(3px);
  }
`
